import { Order, QueryEntity } from '@datorama/akita';
import corporateAccountStore, {
  CorporateAccountStore,
  CorporateAccountState,
} from './corporate-account.store';

export class CorporateAccountQuery extends QueryEntity<CorporateAccountState> {
  constructor(protected store: CorporateAccountStore) {
    super(store);
  }

  accounts = this.selectAll({ sortBy: 'name', sortByOrder: Order.ASC });
  loaded = this.select(state => state.loaded);
  loading = this.selectLoading();
}

export const corporateAccountQuery = new CorporateAccountQuery(corporateAccountStore);
